var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CalenderIcon from "@/components/Icons/CalenderIcon";
import { Select } from "@atom/ui-kit";
import { useTranslation } from "react-i18next";
import { STRICT_DATES } from "./DateSelect.constants";
var DateSelect = function (props) {
    var t = useTranslation().t;
    return (_jsxs(Select, __assign({ defaultValue: STRICT_DATES[0].value, style: { width: "100%", minWidth: "150px" }, suffixIcon: _jsx(CalenderIcon, {}) }, props, { children: [Object.values(STRICT_DATES).map(function (date) { return (_jsx(Select.Option, { value: date.value, children: t("selects.dateSelect." + date.label) }, date.value)); }), _jsx(Select.Option, { value: "custom", children: t("selects.dateSelect.custom") }, "custom")] })));
};
export default DateSelect;
